import * as req from 'api/actions';
import * as c from './constant';

export const getRoofList = (buildingId, payload, callback) =>
  req.list(
    c.GET_ROOF_LIST,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_structural_materials`,
    payload,
    callback
  );

  export const getFlooringList = (buildingId, payload, callback) =>
  req.list(
    c.GET_FLOORING_LIST,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_structural_materials`,
    payload,
    callback
  );

  export const getWallsAndPartitionList = (buildingId, payload, callback) =>
  req.list(
    c.GET_WALLS_AND_PARTITION_LIST,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_structural_materials`,
    payload,
    callback
  );

export const showData = (buildingId, id, payload, callback) =>
  req.item(
    c.SHOW_DATA,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_structural_materials/${id}`,
    payload,
    callback
  );

export const updateData = (buildingId, payload, callback) =>
  req.update(
    c.UPDATE_DATA,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_structural_materials`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

  export const getBuildingMaterialTypeList = (payload, callback) =>
  req.list(
    c.GET_BUILDING_MATERIAL_TYPE,
    'api/v1/rpt/administrator/buildings/settings/building_material_types',
    payload,
    callback
  );

  export const getFloorList = (buildingId, payload, callback) =>
  req.list(
    c.GET_FLOOR_LIST,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_floor_storey_areas`,
    payload,
    callback
  );

  export const getSingleMaterialType = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_BUILDING_MATERIAL_TYPE,
    `api/v1/rpt/administrator/buildings/settings/building_material_types/${id}`,
    payload,
    callback
  );

  export const getSingleMaterial = (id, materialId, payload, callback) =>
    req.item(
      c.GET_SINGLE_BUILDING_MATERIAL,
      `api/v1/rpt/administrator/buildings/settings/building_material_types/${id}/building_materials/${materialId}`,
      payload,
      callback
    );